import { useState, useEffect, useRef } from "react";
export default function NewStoneRange() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const products = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/Contemporary-garden_20seating_20in_20London.webp",
    alt: "Kara Limestone",
    name: "Kara Limestone",
    description: "Available in flamed and sandblasted finishes, complete with a beautifully tumbled edge for a soft, characterful look.",
    index: 0
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/A-lush_20garden_20with_20limestone_20patio.webp",
    alt: "Antique Limestone",
    name: "Antique Limestone",
    description: "Available in 3 styles, our Antique Limestones feature a riven and brushed surface, a sawn or natural edge and a light tumble for added character.",
    index: 1
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/2.webp",
    alt: "Egyptian Limestone",
    name: "Egyptian Limestone",
    description: "Egyptian Limestone is on trend, hard-wearing and effortlessly stylish. Now available in five distinctive finishes.",
    index: 2
  }];
  return;
}